<template>
  <div>
    <div class="breadcrumb-wrapper">
      <ul class="breadcrumb-list">
        <li>
          <router-link :to="{ name: 'HomePage' }">
            <i class="fa fa-home"></i>
            Home
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'ProductList' }">
            <i class="fa fa-stars"></i>
            Star Collection
          </router-link>
        </li>
        <li class="active" v-if="productDetail">
          <i class="fa fa-star"></i>
          {{ productDetail.Name }}
        </li>
      </ul>
    </div>

    <div class="page-content-wrapper">
      <div class="single-product-slider-details-area">
        <div class="container">
          <div class="text-center" v-if="loading == 'Detail'">
            <loading />
          </div>

          <div class="row" v-if="productDetail">
            <div class="col-lg-7">
              <!--=======  product details slider area  =======-->

              <div
                class="
                  product-details-slider-area
                  product-details-slider-area--side-move
                "
              >
                <!-- <div class="product-badge-wrapper">
                  <span class="hot">Hot</span>
                </div> -->

                <div class="row row-5">
                  <div v-if="!is360Load" class="col-md-12">
                    <img
                      v-if="productDetail.ThumbnailImage"
                      :src="`${$http.defaults.baseURL}/Document/download/Thumbnails/${productDetail.ThumbnailImage.FileName}`"
                      class="img-fluid"
                      alt=""
                    />
                    <img
                      v-else
                      src="/img/No_Picture.png"
                      class="img-fluid"
                      alt=""
                    />
                  </div>
                  <room-scene
                    v-show="roomScene == 'RS1'"
                    :productDetail="productDetail"
                    :features="features"
                    prefix="RS1"
                    @hasRoomScene="(e) => (hasRoomScene1 = e)"
                  />
                  <room-scene
                    v-show="roomScene == 'RS2'"
                    :productDetail="productDetail"
                    :features="features"
                    prefix="RS2"
                    @hasRoomScene="(e) => (hasRoomScene2 = e)"
                  />
                  <div
                    v-show="roomScene != 'RS1' && roomScene != 'RS2'"
                    id="put-viewer-here"
                  ></div>
                  <div class="col-md-12" v-if="productDetail.Has360">
                    <div class="text-center">
                      <ul class="roomscene nav nav-tabs justify-content-center">
                        <li class="nav-item">
                          <a
                            class="nav-link text-success fw-bold"
                            :class="{ 'active text-dark': roomScene == '' }"
                            href="javascript:"
                            @click="roomScene = ''"
                          >
                            <i class="fa fa-cube"></i>
                            3D Studio
                          </a>
                        </li>
                        <li class="nav-item" v-if="hasRoomScene1">
                          <a
                            class="nav-link text-success fw-bold"
                            :class="{ 'active text-dark': roomScene == 'RS1' }"
                            href="javascript:"
                            @click="roomScene = 'RS1'"
                          >
                            <i class="fa fa-street-view"></i>
                            Scene 1
                          </a>
                        </li>
                        <li class="nav-item" v-if="hasRoomScene2">
                          <a
                            class="nav-link text-success fw-bold"
                            :class="{ 'active text-dark': roomScene == 'RS2' }"
                            href="javascript:"
                            @click="roomScene = 'RS2'"
                          >
                            <i class="fa fa-street-view"></i>
                            Scene 2
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <!--=======  End of product details slider area  =======-->
            </div>
            <div class="col-lg-5">
              <!--=======  product details description area  =======-->

              <div class="product-details-description-wrapper">
                <div class="mb-4 detail-title">
                  <h2 class="item-title">{{ productDetail.Name }}</h2>
                  <p class="mb-0" v-if="productDetail.ShortDescription">
                    {{ productDetail.ShortDescription }}
                  </p>
                </div>

                <div
                  v-for="(material, i) in materials"
                  :key="`material-${i}`"
                  class="product-color"
                >
                  <div
                    class="product-details-title"
                    role="button"
                    @click="material.expanded = !material.expanded"
                  >
                    <span class="text-uppercase fw-bold">
                      {{
                        $const.MATERIAL_TYPES[material.type]
                          ? $const.MATERIAL_TYPES[material.type]
                          : material.type
                      }}
                      <i v-if="material.expanded" class="fa fa-angle-up"></i>
                      <i v-else class="fa fa-angle-down"></i>
                    </span>

                    <span v-if="material.dangerMessage" class="text-danger">
                      {{ material.dangerMessage }}
                    </span>
                  </div>
                  <div
                    class="row"
                    v-if="
                      material.list && material.list.length && material.expanded
                    "
                  >
                    <div
                      class="col-6 col-lg-4"
                      v-for="(item, j) in material.list.filter(
                        (m) => !m.hidden
                      )"
                      :key="`material-${i}-${j}`"
                    >
                      <a
                        href="javascript:"
                        class="d-block mb-2 text-black text-center rounded p-1"
                        :class="{
                          selected: material.selected == item.code,
                        }"
                        @click="material.selected = item.code"
                      >
                        <div class="img-container">
                          <!-- <div
                            v-if="item.code == 'NONE'"
                            class="material-img"
                          ></div> -->
                          <img
                            :src="`${
                              $http.defaults.baseURL
                            }/Document/download/Materials/${item.code.replace(
                              '/',
                              '-'
                            )}.jpg`"
                            alt=""
                            class="material-img"
                          />
                        </div>
                        <div>
                          <span class="material-name">{{ item.name }}</span
                          ><br />
                          <span class="material-code">{{ item.code }}</span>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>

                <div class="quick-view-other-info">
                  <div class="row mb-2">
                    <div class="col-5 quickview-title fw-bold">
                      Drawing Code:
                    </div>
                    <div class="col-7 quickview-value">
                      {{ drawingCode }}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-5 quickview-title fw-bold">
                      Product Type:
                    </div>
                    <div class="col-7 quickview-value">
                      {{ productDetail.ProductType }}
                    </div>
                  </div>
                  <div
                    class="row mb-2"
                    v-if="productTestReports && productTestReports"
                  >
                    <div
                      v-for="(file, i) in productTestReports"
                      :key="`doc-${i}`"
                      class="col-12 quickview-value"
                    >
                      <a
                        href="javascript:"
                        class="text-primary"
                        @click="downloadDocument(file)"
                      >
                        <i
                          v-if="file.FileType == 'pdf'"
                          class="fa fa-file-pdf"
                        ></i>
                        <i
                          v-else-if="
                            file.FileType == 'xlsx' || file.FileType == 'xls'
                          "
                          class="fa fa-file-excel"
                        ></i>
                        <i
                          v-else-if="
                            file.FileType == 'docx' || file.FileType == 'doc'
                          "
                          class="fa fa-file-word"
                        ></i>
                        <i v-else class="fa fa-file"></i>
                        <span class="small ms-1">{{ file.FileName }}</span>
                      </a>
                    </div>
                  </div>
                </div>

                <loading v-if="loading == 'Packing'" />
                <div
                  v-if="d365Detail && d365Detail.productPackings"
                  class="table-responsive packing-option"
                >
                  <table class="table small">
                    <tbody>
                      <template v-for="(item, i) in d365Detail.productPackings">
                        <tr :key="`tr1-${i}`">
                          <td colspan="4">
                            <b>
                              <i class="fa fa-box-open"></i>
                              {{ item.packingOptionType }}
                              -
                              {{ item.packingTypeId }}
                            </b>
                          </td>
                        </tr>
                        <tr :key="`tr2-${i}`">
                          <td><b>Open Dimension</b></td>
                          <td>
                            {{ item.openDimL.toFixed(2) }}-{{
                              item.openDimW.toFixed(2)
                            }}-{{ item.openDimH.toFixed(2) }}
                            (cm)
                          </td>
                          <td><b>Carton Dimension</b></td>
                          <td>
                            {{ item.cartonL.toFixed(2) }}-{{
                              item.cartonW.toFixed(2)
                            }}-{{ item.cartonH.toFixed(2) }}
                            (cm)
                          </td>
                        </tr>
                        <tr :key="`tr3-${i}`">
                          <td><b>Gross Weight</b></td>
                          <td>{{ item.grossWeight.toFixed(2) }} (kg)</td>
                          <td><b>Net Weight</b></td>
                          <td>{{ item.netWeight.toFixed(2) }} (kg)</td>
                        </tr>
                        <tr :key="`tr4-${i}`">
                          <td><b>Box Weight</b></td>
                          <td>{{ item.boxWeight.toFixed(2) }} (kg)</td>
                          <td><b>ConLoad20Pcs</b></td>
                          <td>{{ item.conLoad20Pcs.toFixed(2) }}</td>
                        </tr>
                        <tr :key="`tr5-${i}`">
                          <td><b>ConLoad20Per</b></td>
                          <td>{{ item.conLoad20Per.toFixed(2) }}</td>
                          <td><b>ConLoad40HPcs</b></td>
                          <td>{{ item.conLoad40HPcs.toFixed(2) }}</td>
                        </tr>
                        <tr :key="`tr6-${i}`">
                          <td><b>ConLoad40HPer</b></td>
                          <td>{{ item.conLoad40HPer.toFixed(2) }}</td>
                          <td><b>ConLoad40Pcs</b></td>
                          <td>{{ item.conLoad40Pcs.toFixed(2) }}</td>
                        </tr>
                        <tr :key="`tr7-${i}`">
                          <td><b>PcsPerBox</b></td>
                          <td>{{ item.pcsPerBox }}</td>
                          <td><b></b></td>
                          <td></td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>

                <div id="fixedAction" />
                <div
                  class="add-to-cart-btn d-inline-block mt-4 text-center"
                  :class="{ 'fixed-action bg-white border-5': isFixedAction }"
                >
                  <loading v-if="loading" />
                  <template v-else>
                    <button
                      v-if="wasAddedCollection"
                      class="btn btn-success"
                      disabled
                    >
                      <i class="fa fa-lock"></i>
                      Added to collection
                    </button>
                    <button
                      v-else
                      class="btn btn-success"
                      @click="addToCollection"
                    >
                      <i class="fa fa-couch"></i>
                      Add to collection
                    </button>
                    <span
                      class="fw-bold px-3 fs-4 text-danger float-end"
                      v-if="basePrice && !isGuest"
                    >
                      ${{ basePrice }}
                    </span>
                    <!-- <router-link
                      v-if="wasAddedCollection"
                      :to="{ name: 'MyCollection' }"
                      class="text-primary ms-3"
                    >
                      <i class="fa fa-couch"></i>
                      Go to Collection
                    </router-link> -->
                  </template>
                </div>
              </div>

              <!--=======  End of product details description area  =======-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import roomScene from "./RoomScene.vue";
import loading from "@/components/Loading.vue";
export default {
  components: {
    roomScene,
    loading,
  },
  data() {
    return {
      productDetail: null,
      materials: [],
      viewerInstance: null,
      loading: "",
      is360Load: false,
      hasRoomScene1: false,
      hasRoomScene2: false,
      roomScene: "",
      isFixedAction: true,
      d365Detail: null,
      features: [],
      userType: null,
    };
  },
  async mounted() {
    let resp = await this.$http.get(`Settings/UserInfo`);
    if (resp && resp.status == 200 && resp.data) {
      let respData = resp.data;
      this.userType = respData.data.userType;
    }

    let slug = this.$route.params.slug;
    if (slug) {
      this.loadProductDetail(slug);
    } else {
      this.productDetail = null;
    }

    this.scroll();
  },
  computed: {
    collection() {
      return this.$collection.getters.collection;
    },
    wasAddedCollection() {
      let collection = this.collection;
      let productDetail = this.productDetail;
      let materials = this.materials;

      return collection.some((_) => {
        let materialConfigs = _.Materials
          ? JSON.parse(_.Materials).MaterialConfigs
          : null;
        let addedMaterial =
          materialConfigs && materials
            ? materialConfigs.every((m) =>
                materials.some((r) => r.type == m.Type && r.selected == m.Code)
              )
            : false;
        return _.ProductId == productDetail.Id && addedMaterial;
      });
    },

    basePrice() {
      let productDetail = this.productDetail;
      let materials = this.materials;

      if (productDetail && productDetail.Price) {
        let price = productDetail.Price;
        if (productDetail.PricePanel) {
          let isSidePanel = materials.some(
            (m) => m.type == "SIDE PANELS" && m.selected != "NONE"
          );
          if (isSidePanel) {
            price = productDetail.PricePanel;
          }
        }
        return this.$func.addCommas(price.toFixed(2));
      }
      return "";
    },

    productTestReports() {
      let d365Detail = this.d365Detail;
      if (
        d365Detail &&
        d365Detail.detail &&
        d365Detail.detail.productTestReport
      ) {
        return JSON.parse(d365Detail.detail.productTestReport);
      }
      return null;
    },

    drawingCode() {
      let productDetail = this.productDetail;
      let materials = this.materials;

      let drawingCode = "";
      if (productDetail.ProductDrgs && productDetail.ProductDrgs.length) {
        productDetail.ProductDrgs.forEach((drg) => {
          if (drg.MaterialType && drg.MaterialKeyword) {
            let isSelectedDrg = materials.some(
              (m) =>
                m.type == drg.MaterialType &&
                m.selected.includes(drg.MaterialKeyword)
            );
            if (isSelectedDrg) {
              drawingCode = drg.DrawingCode;
            }
          } else {
            drawingCode = drg.DrawingCode;
          }
        });
      } else {
        drawingCode = productDetail.DrawingCode;
      }
      return drawingCode;
    },

    isGuest() {
      return this.userType == this.$const.USER_TYPES.Guest;
    },
  },
  watch: {
    materials: {
      deep: true,
      handler(val) {
        if (val && val.length) {
          let materials = val;
          let features = [];
          materials.forEach((_) => {
            let types = ["TABLE FRAME", "SOFA FRAME"];
            if (!this.isMatchingColorInSet(materials, _.type, types)) {
              _.dangerMessage = `Make sure to match with ${
                types.filter((t) => t != _.type)[0]
              }`;
            } else {
              _.dangerMessage = null;
            }

            features.push(_.type);
            features.push(_.selected);
          });
          if (this.viewerInstance && features && features.length) {
            this.viewerInstance.setFeatures(features);
          }
          this.features = features;
        }
      },
    },
    async productDetail(val) {
      this.loading = "Packing";
      if (val) {
        this.d365Detail = await this.getD365Detail(val);
      } else {
        this.d365Detail = null;
      }
      this.loading = "";
    },
  },
  methods: {
    async loadProductDetail(slug) {
      this.loading = "Detail";
      try {
        this.productDetail = null;
        let filters = [];
        filters.push(`Slug eq '${slug}'`);
        let resp = await this.$http.get(`odata/Product`, {
          params: {
            $top: 1,
            $filter: filters.join(" and "),
            $expand: `ThumbnailImage, ProductDrgs($select=MaterialType,MaterialKeyword,DrawingCode)`,
          },
        });
        if (resp && resp.status == 200) {
          let productDetail = resp.data.value[0];
          this.productDetail = productDetail;

          this.loadViewer(productDetail.ItemNumber);
        }
      } catch (error) {
        this.$swal({ text: error.message });
      }
      this.loading = "";
    },

    async loadViewer(itemNumber) {
      try {
        this.is360Load = false;
        let customer = 5037;
        let resp = await this.$http.get(
          `https://content.cylindo.com/api/v2/${customer}/products/${itemNumber}/configuration`
        );
        if (resp && resp.status == 200) {
          this.is360Load = true;
          let productInfo = resp.data;
          this.viewerInstance = null;
          let opts = {
            accountID: productInfo.customer,
            productCode: productInfo.code,
            containerID: "#put-viewer-here",
            version: productInfo.version,
          };

          let features = productInfo.features;
          this.getMaterials(features);

          if (window.cylindo) {
            window.cylindo.on("ready", () => {
              this.viewerInstance = window.cylindo.viewer.create(opts);
            });
          }
        }
      } catch (error) {
        //this.$swal({ text: error.message });
      }
    },

    async getMaterials(features) {
      this.loadingMaterial = true;
      try {
        this.materials = [];
        let filters = [];

        let optionCodes = [];
        features.forEach((feature) => {
          feature.options.forEach((option) => {
            optionCodes.push(option.code);
          });
        });

        filters.push(`MaterialCode in ('${optionCodes.join("','")}')`);
        let resp = await this.$http.get(`odata/Material`, {
          params: {
            $top: 100,
            $filter: filters.join(" and "),
          },
        });
        if (resp && resp.status == 200) {
          let materialInfos = resp.data.value;
          this.materials = features
            .sort((a, b) => {
              if (a.code > b.code) {
                return -1;
              }
              if (a.code < b.code) {
                return 1;
              }
              return 0;
            })
            .map((feature) => {
              let list = feature.options.map((option) => {
                let optionObj = materialInfos.find(
                  (_) => _.MaterialCode == option.code
                );
                return {
                  code: option.code,
                  name: optionObj ? optionObj.MaterialName : option.code,
                  hidden:
                    optionObj &&
                    optionObj.Notes &&
                    (optionObj.Notes.includes("hidden") ||
                      optionObj.Notes.includes(`${feature.code}:hide`)),
                };
              });
              return {
                type: feature.code,
                list,
                selected: list.length ? list[0].code : "",
                expanded: true,
                dangerMessage: null,
              };
            });
        }
      } catch (error) {
        this.$swal({ text: error.message });
      }
      this.loadingMaterial = false;
    },

    addToCollection() {
      let viewerInstance = this.viewerInstance;
      let productDetail = this.productDetail;
      let d265Detail = this.d365Detail;
      let materials = this.materials;
      let materialConfigs = materials.map((_) => {
        let selectedObj = _.list
          ? _.list.find((s) => s.code == _.selected)
          : null;
        return {
          Type: _.type,
          Code: _.selected,
          Name: selectedObj ? selectedObj.name : null,
        };
      });
      let packingOption =
        d265Detail && d265Detail.productPackings
          ? d265Detail.productPackings[0]
          : null;
      this.$collection.dispatch("addToCollection", {
        product: productDetail,
        materials: {
          ItemNumber: productDetail.ItemNumber,
          ProductType: productDetail.ProductType,
          MaterialConfigs: materialConfigs,
          DrawingCode: this.drawingCode,
          ShortDescription: productDetail.ShortDescription,
          Description: productDetail.MetaDescription,
          LoadingInfo: this.renderLoadingInfo(packingOption),
          OpenDimension: this.renderOpenDimension(packingOption),
          Packing: this.renderPacking(packingOption),
          CartonDimension: this.renderCartonDimension(packingOption),
          PalletDimension: this.renderPalletDimension(packingOption),
          ConLoad20Pcs: packingOption ? packingOption.conLoad20Pcs : "",
          ConLoad40Pcs: packingOption ? packingOption.conLoad40Pcs : "",
          ConLoad40HPcs: packingOption ? packingOption.conLoad40HPcs : "",
          NetWeight: packingOption ? packingOption.netWeight : "",
          GrossWeight: packingOption ? packingOption.grossWeight : "",
          ConCbm3: packingOption ? packingOption.conCbm3 : "",
        },
        configImage: viewerInstance
          ? viewerInstance.getCurrentImageUrl()
          : null,
      });

      this.$swal({
        position: "top-end",
        icon: "success",
        title: "",
        text: "Add to your collection successfully!",
        showConfirmButton: false,
        timer: 1500,
      });
    },

    renderLoadingInfo(packingOption) {
      return packingOption &&
        (packingOption.conLoad20Pcs ||
          packingOption.conLoad40Pcs ||
          packingOption.conLoad40HPcs)
        ? [
            packingOption.conLoad20Pcs,
            packingOption.conLoad40Pcs,
            packingOption.conLoad40HPcs,
          ]
            .filter((_) => _)
            .map((_) => `${_} (est)`)
            .join(" / ")
        : "TBA";
    },

    renderOpenDimension(packingOption) {
      return packingOption &&
        (packingOption.openDimL ||
          packingOption.openDimW ||
          packingOption.openDimH)
        ? [
            packingOption.openDimL,
            packingOption.openDimW,
            packingOption.openDimH,
          ]
            .filter((_) => _)
            .join(" x ")
        : "TBA";
    },

    renderCartonDimension(packingOption) {
      return packingOption &&
        (packingOption.cartonL ||
          packingOption.cartonW ||
          packingOption.cartonH)
        ? [packingOption.cartonL, packingOption.cartonW, packingOption.cartonH]
            .filter((_) => _)
            .join(" x ")
        : "TBA";
    },

    renderPalletDimension(packingOption) {
      return packingOption ? "TBA" : "TBA";
    },

    renderPacking(packingOption) {
      return packingOption && packingOption.pcsPerBox
        ? `${packingOption.pcsPerBox} ${packingOption.packingTypeId}`
        : "TBA";
    },

    isScrolledIntoView(el) {
      let rect = el.getBoundingClientRect();
      let elemTop = rect.top;
      let elemBottom = rect.bottom;
      //let isVisible = elemTop < window.innerHeight && elemBottom >= 0;
      let isVisible = window.innerHeight < elemTop && elemBottom >= 0;
      return isVisible;
    },

    scroll() {
      window.onscroll = () => {
        let scrolledTo = document.querySelector("#fixedAction");

        if (scrolledTo) {
          this.isFixedAction = this.isScrolledIntoView(scrolledTo);
        }
      };
    },

    isMatchingColorInSet(materials, curType, types) {
      // table frame and sofa frame diff notes
      if (types.includes(curType)) {
        let matchTypes = materials.filter(
          (_) => types.includes(_.type) && _.selected
        );
        return (
          matchTypes &&
          matchTypes.length == types.length &&
          [...new Set(matchTypes.map((_) => _.selected))].length == 1
        );
      } else {
        return true;
      }
    },

    async getD365Detail(productDetail) {
      try {
        let resp = await this.$http.get(`/d365/product-detail`, {
          params: {
            itemNumber: productDetail.ItemNumber,
            getPackingOption: true,
            singlePacking: true,
          },
        });
        if (resp && resp.status == 200) {
          return resp.data.data;
        } else {
          return null;
        }
      } catch (error) {
        return null;
      }
    },

    async downloadDocument(file) {
      // let filePath = encodeURIComponent(file.PathFile);
      let filePath = file.PathFile.replaceAll("\\", "$");
      let resp = await this.$http.get(
        `document/download/${file.FileType}/${filePath}?d365=true`,
        {
          responseType: "arraybuffer",
        }
      );
      if (resp && resp.status == 200) {
        let fileName = `${file.FileName}.${file.FileType}`;
        let blob = new Blob([resp.data], {
          type: `application/${file.FileType}`,
        });

        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.img-container {
  width: 70px;
  height: 70px;
  display: inline-block;
  border-radius: 50%;
  overflow: hidden;
  position: relative;
  border: 2px solid #dedede;
}
.selected {
  background-color: #dedede;

  & > .img-container {
    border-color: #fff;
  }
}
.material-img {
  position: absolute;
  width: 100px;
  height: 100px;
  left: -25%;
  top: -25%;
}

.product-color {
  margin-bottom: 0;

  ul {
    padding-left: 0;
  }
}

.material-name {
  white-space: nowrap;
  font-weight: 600;
  font-size: 0.8rem;
  margin-left: -0.3rem;
}
.material-code {
  font-size: 0.7rem;
  font-style: italic;
}

.product-details-title {
  font-size: 1rem;
  color: #000;
}

.fixed-action {
  position: fixed;
  bottom: 0;
}

.product-details-slider-area {
  position: sticky;
  top: 0;
  margin-bottom: 0;
}

#put-viewer-here {
  max-height: calc(100vh - 45px);
}

.product-color {
  .row > * {
    padding-left: 0;
  }
}

// .detail-title {
//   position: sticky;
//   right: 0;
//   top: 50px;
//   z-index: 1;

//   .discounted-price {
//     background-color: #fff;
//     padding: 0 0.5rem;
//     border-bottom-left-radius: 5px;
//     border-bottom-right-radius: 5px;
//   }
// }

.packing-option {
  td {
    padding-left: 0;
  }
}

.roomscene {
  &.nav-tabs {
    border-bottom: none;
    border-top: 1px solid #dee2e6;

    .nav-link {
      margin-top: -1px;
      margin-bottom: unset;
      border-top-left-radius: unset;
      border-top-right-radius: unset;
      border-bottom-left-radius: 0.25rem;
      border-bottom-right-radius: 0.25rem;

      &.active {
        border-color: #fff #dee2e6 #dee2e6;
      }
    }
  }
}
</style>
